/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAiAgentConfigConsentStatus } from '../../axios/whatsAppAiAgentConfigConsentStatus'
import type {
	WhatsAppAiAgentConfigConsentStatusError,
	WhatsAppAiAgentConfigConsentStatusPathParams,
	WhatsAppAiAgentConfigConsentStatusResponse,
} from '../../types/WhatsAppAiAgentConfigConsentStatus'

export const whatsAppAiAgentConfigConsentStatusQueryKey = (
	organisationId: WhatsAppAiAgentConfigConsentStatusPathParams['organisationId'],
) => [{ url: '/organisations/:organisationId/whatsapp-ai-consent', params: { organisationId } }] as const

export type WhatsAppAiAgentConfigConsentStatusQueryKey = ReturnType<typeof whatsAppAiAgentConfigConsentStatusQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::consentStatus */
export function whatsAppAiAgentConfigConsentStatusQueryOptions(
	organisationId: WhatsAppAiAgentConfigConsentStatusPathParams['organisationId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppAiAgentConfigConsentStatusResponse,
		AxiosError<WhatsAppAiAgentConfigConsentStatusError>,
		WhatsAppAiAgentConfigConsentStatusResponse,
		WhatsAppAiAgentConfigConsentStatusQueryKey
	>({
		queryKey: whatsAppAiAgentConfigConsentStatusQueryKey(organisationId),
		queryFn: ({ signal }) =>
			whatsAppAiAgentConfigConsentStatus(organisationId, { signal, ...config }).then(res => res.data),
		enabled: !!organisationId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::consentStatus */
export function useWhatsAppAiAgentConfigConsentStatus<TSelectData = WhatsAppAiAgentConfigConsentStatusResponse>(
	organisationId: WhatsAppAiAgentConfigConsentStatusPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppAiAgentConfigConsentStatusResponse,
					AxiosError<WhatsAppAiAgentConfigConsentStatusError>,
					TSelectData,
					WhatsAppAiAgentConfigConsentStatusQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppAiAgentConfigConsentStatusError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppAiAgentConfigConsentStatusQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::consentStatus */
export function useWhatsAppAiAgentConfigConsentStatusSuspense<TSelectData = WhatsAppAiAgentConfigConsentStatusResponse>(
	organisationId: WhatsAppAiAgentConfigConsentStatusPathParams['organisationId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppAiAgentConfigConsentStatusResponse,
					AxiosError<WhatsAppAiAgentConfigConsentStatusError>,
					TSelectData,
					WhatsAppAiAgentConfigConsentStatusQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppAiAgentConfigConsentStatusError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppAiAgentConfigConsentStatusQueryOptions(organisationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
